<template>
    <div class="row gy-2">
        <div class="col-12">
            <h5 class="mb-3">List of Beneficiaries</h5>
            <div class="row mb-3 gy-2 justify-content-between">
                <div class="col-md-6 col-lg-5 d-flex">
                    <div class="dropdown no-arrow me-2">
                        <a class="btn btn-light bg-white dropdown-toggle" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bx bx-menu"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li @click.prevent="exportSelected()">
                                <button class="dropdown-item" type="button">
                                    Export Excel
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="input-group w-auto">
                        <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage"
                            :options="pageOptions"></b-form-select>
                    </div>
                </div>
                 <div class="col-md-5">
                    <div class="input-group mb-0">
                        <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenu2"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="ri ri-filter-2-line align-bottom"></i> Filters
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                            <div class="p-3">
                                <label class="form-label small">Category</label>
                                <select @change="fetchItems()" v-model="categoryForm.category_id"
                                    class="form-select form-select-sm">
                                    <option value="" disabled selected>-- category --</option>
                                    <option value=""> All </option>
                                    <option v-for="(option, tIndex) in categoryOptions" :value="option.id"
                                        :key="tIndex"> {{ option.title }} </option>
                                </select>
                                <div class="pt-3">
                                    <button @click="clearCategoryForm(); fetchItems()" class="btn btn-sm p-0 btn-link"
                                        type="button"><span class="mdi mdi-close"></span> Clear</button>
                                </div>
                            </div>
                        </div>
                        <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control"
                            placeholder="Search here..." aria-label="Search here..."
                            aria-describedby="button-search_TB">
                        <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span
                                class="ri ri-search-line"></span></button>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <p class="mb-0">Showing {{ paginationInfo }} results</p>
            </div>
            <div v-if="isLoading" class="loading-viewport">
                <CommonSpinner v-if="isLoading" :box="true" />
            </div>
            <div v-else class="row">
                <div v-for="(item, iIndex) in pageData.data" :key="iIndex" class="col-sm-6 col-lg-4  col-xxl-3">
                    <beneficiary-card :item="item" />
                </div>
            </div>
            <div class="mb-4">
                <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
                    :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';
import { categoryOptionMixin } from '@/mixins/categoryOptionMixin';
import BeneficiaryCard from '../../components/cards/BeneficiaryCard.vue';

export default {
  components: { BeneficiaryCard },
    name: "beneficiary-list",
    mixins: [
        commonPaginationMixin,
        categoryOptionMixin,
    ],
    data() {
        return {
            isLoading: false,

            searchQuery: "",
            columns: [
                { key: "check" },
                "action",
                { key: "user_image", width: 10, auto: false, label: "Employee" },
                { key: "monthly_deduction", auto: false, label: "Monthly Deduction", sortable: true },
                { key: "accumulated_amount", auto: true, label: "Accumulated Amount (₦)", sortable: true },
                { key: "amount_carried_forward", auto: true, label: "Amount Carried Forward (₦)" },
                { key: "amount_type", auto: true, label: "Amount Type", sortable: true },
                { key: "status", auto: true, label: "Status", sortable: true },
                { key: "group_name", auto: true, width: 15, label: "Group" },
                { key: "started_at", auto: true, label: "Started At", sortable: true },
                { key: "completed_at", auto: true, width:9, label: "Completed At", sortable: true },
                { key: "updated_at", auto: true, width:7, label: "Updated at", sortable: true },
                { key: "created_at", auto: true, width:7, label: "Created At", sortable: true }
            ],
            sortBy: {
                sort_column: "created_at",
                sort_direction: "desc"
            },
            pageData: {
                data: []
            },
        }
    },
    methods: {
        navigateTo(item) {
        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
                ...this.sortBy,
                ...this.$filters.validFields({
                    ...(this.categoryForm ?? {})
                })
            }
            if (this.searchQuery) { payload.search = this.searchQuery }

            this.isLoading = true
            this.$http.get(`/beneficiaries?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        initializeAll() {
        },
    },
    created() {
        this.fetchCategories('PROGRAM')
        this.fetchItems()
    },
}

</script>
